import { render, staticRenderFns } from "./productSoftware.vue?vue&type=template&id=f7600aca&scoped=true"
import script from "./productSoftware.vue?vue&type=script&lang=js"
export * from "./productSoftware.vue?vue&type=script&lang=js"
import style0 from "./productSoftware.vue?vue&type=style&index=0&id=f7600aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7600aca",
  null
  
)

export default component.exports